<div #multiwell class="tbmultiwell-panel">
  <mat-drawer-container class="tbmulti-well-container" autosize>
    <mat-drawer #drawer class="tbwell-sidenav" mode="side">
      <div class="tbwell-available-selection">
        <div position="top" class="p-1 k-header k-grid-toolbar ng-star-inserted">
          <button type="button" kendoButton themeColor="primary" type="button" (click)="addSelectedRows()" [disabled]="availableWells.length === 0" class="k-button k-primary">
            Add Selected
          </button>
          <button type="button" kendoButton themeColor="primary" type="button" (click)="clearAvailableRows()" class="k-button k-primary">
            Cancel
          </button>
        </div>
        <ag-grid-angular #agSelectionGrid style="height: 450px;" class="ag-theme-balham"
          [gridOptions]="assetMappingTankBatteryGridOptions" (filterChanged)="onAvailableFilterChanged($event)"
          (selectionChanged)="onAvailableSelectionChanged($event)">
        </ag-grid-angular>
      </div>
    </mat-drawer>

    <div class="tbwell-sidenav-content">
      <div position="top" class="p-1 k-header k-grid-toolbar ng-star-inserted">
        <button type="button" kendoButton themeColor="primary" type="button" (click)="removeSelectedRows()" [disabled]="selectedWells.length === 0" class="k-button k-primary">
          Remove Selected
        </button>
        <button type="button" kendoButton themeColor="primary" type="button" (click)="clearSelectedRows()" class="k-button k-primary">
          Cancel
        </button>
      </div>
      <ag-grid-angular #agDataGrid style="height: 450px;" class="ag-theme-balham" (gridReady)="onSelectedGridReady($event)"
        [gridOptions]="assetMappingTankBatterySelectedGridOptions" (selectionChanged)="onSelectedSelectionChanged($event)">
      </ag-grid-angular>
    </div>
  </mat-drawer-container>
</div>
@if (openedWarning) {
  <kendo-dialog title="Please confirm" (close)="onWarningClose()" [minWidth]="250" [width]="450">
    <div>
      <p>These Well(s) are currently assigned to another Tank Battery Asset, do you want to proceed and override the Asset Mapping?</p>
    </div>
    <kendo-dialog-actions>
      <button type="button" kendoButton (click)="onWarningClose()">No</button>
      <button type="button" kendoButton (click)="onWarningSave()">Yes</button>
    </kendo-dialog-actions>
  </kendo-dialog>
}